import Index from "../components/terms/Index.vue"
import init from "../root_init"
init(Index)
